module.exports = __webpack_public_path__ + "img/war_cemetery.09d51e3d.jpg";